export default {
  lastModification: 'Last modification:',
  createdBy: 'Created by:',
  on: 'on',
}
